import { fileConstants } from '../constants'
import {
    getDocumentationInfo,
    getOptions,
    getDocsForApproval,
    getChecksStage,
    getValidations,
    getSections,
    getNameDocINE,
    getNameDocEvidence
} from '../../utils';

export const File = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.UPDATE_METADATA_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.UPDATE_METADATA_SUCCESS:
            return { loading: false, items: action.fileData.Body, error: undefined }

        case fileConstants.UPDATE_METADATA_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FileByGUID = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILE_GUID_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case fileConstants.FILE_GUID_SUCCESS:
            return {
                loading: false,
                items: action.fileInfoGuid.Body,
                error: undefined
            }
            
        case fileConstants.FILE_GUID_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const FileInfo = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILE_INFO_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILE_INFO_SUCCESS:
            return {
                loading: false,
                items: action.fileInfo.Body,
                itemsDocs: getDocumentationInfo(action.fileInfo.Body),
                itemsDocOptions: getOptions(action.fileInfo.Body),
                itemsDocsToApproved: getDocsForApproval(action.fileInfo.Body),
                itemsCheks: getChecksStage(action.fileInfo.Body.Stage),
                itemsValidation: getValidations(action.fileInfo.Body),
                itemsSections: getSections(action.fileInfo.Body.DocumentalCategories[0]?.DocumentalGroups, action.fileInfo.Body.Stage),
                // itemsSections: getSections(action.fileInfo.Body.Stage.DocumentalCategory?.DocumentalGroups),
                itemNameDoc: getNameDocINE(action.fileInfo.Body.DocumentalCategories[0]?.DocumentalGroups, action.fileInfo.Body.Stage),
                // itemNameDocCurrent: getNameDocCurrent(action.fileInfo.Body.Stage),
                itemNameDocEvidence: getNameDocEvidence(action.fileInfo.Body.DocumentalCategories[0]?.DocumentalGroups),
                error: undefined
            }

        case fileConstants.FILE_INFO_FAILURE:
            return { loading: false, items: undefined, error: action.error }
        case fileConstants.FILE_INFO_RESET:
            return { loading: false, items: undefined, error: undefined };
        default:
            return state
    }
}

export const FileCheck = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILE_CHECK_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILE_CHECK_SUCCESS:
            return { loading: false, items: action.fileCheck.Body, error: undefined }

        case fileConstants.FILE_CHECK_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FileText = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILE_TEXT_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILE_TEXT_SUCCESS:
            return { loading: false, items: action.fileText.Body, error: undefined }

        case fileConstants.FILE_TEXT_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FolioChildWf = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FOLIO_WF_REQUEST:
            return { loading: true, items: undefined, error: undefined }
            
        case fileConstants.FOLIO_WF_SUCCESS:
            return { loading: false, items: action.folioChildWf.Body, error: undefined }
            
        case fileConstants.FOLIO_WF_FAILURE:
            return { loading: false, items: undefined, error: action.error }
            
        default:
            return state
    }
}

export const FolioRemote = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FOLIOREMOTE_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FOLIOREMOTE_SUCCESS:
            return { loading: false, items: action.folioRemoteData.Body, error: undefined }

        case fileConstants.FOLIOREMOTE_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FileCheckAcceptance = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILECHECKPDF_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILECHECKPDF_SUCCESS:
            return {
                loading: false,
                items: action.checkPdfData.Body,
                error: undefined
            }

        case fileConstants.FILECHECKPDF_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const OptionsToSelect = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILE_OPTIONS_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILE_OPTIONS_SUCCESS:
            return { loading: false, items: action.options.Body, error: undefined }

        case fileConstants.FILE_OPTIONS_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FilesSearch = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.FILES_SEARCH_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.FILES_SEARCH_SUCCESS:
            return { loading: false, items: action.files.Body, error: undefined }

        case fileConstants.FILES_SEARCH_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FolioInfo = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.GENERATE_FOLIO_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.GENERATE_FOLIO_SUCCESS:
            return { loading: false, items: action.folio.Body, error: undefined }

        case fileConstants.GENERATE_FOLIO_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const GroupSearch = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.SEARCH_GROUP_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.SEARCH_GROUP_SUCCESS:
            return { loading: false, items: action.groupSearch.Body, error: undefined }

        case fileConstants.SEARCH_GROUP_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const Actors = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.GET_ACTORS_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.GET_ACTORS_SUCCESS:
            return { loading: false, items: action.actors.Body, error: undefined }

        case fileConstants.GET_ACTORS_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const GroupNameData = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.GROUP_NAME_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.GROUP_NAME_SUCCESS:
            return { loading: false, items: action.groupName.Body, error: undefined }

        case fileConstants.GROUP_NAME_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const NewActor = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.REGISTER_ACTOR_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.REGISTER_ACTOR_SUCCESS:
            return { loading: false, items: action.newActor.Body, error: undefined }

        case fileConstants.REGISTER_ACTOR_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const StartActor = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.START_ACTOR_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.START_ACTOR_SUCCESS:
            return { loading: false, items: action.startActor.Body, error: undefined }

        case fileConstants.START_ACTOR_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}


export const DeletedActor = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.REMOVE_ACTOR_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.REMOVE_ACTOR_SUCCESS:
            return { loading: false, items: action.deletedActor.Body, error: undefined }

        case fileConstants.REMOVE_ACTOR_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}


export const UpdatedInfo = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.UPDATE_ACTORS_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.UPDATE_ACTORS_SUCCESS:
            return { loading: false, items: action.updatedInfo.Body, error: undefined }

        case fileConstants.UPDATE_ACTORS_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const ManualConfigurations = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.MANUAL_CONFIGURATIONS_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.MANUAL_CONFIGURATIONS_SUCCESS:
            return { loading: false, items: action.manualConfig.Body, error: undefined }

        case fileConstants.MANUAL_CONFIGURATIONS_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const ContinueStageActorSelect = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_SUCCESS:
            return { loading: false, items: action.ContStageActorData.Body, error: undefined }

        case fileConstants.CONTINUE_STAGE_ACTOR_SELECTTION_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FileInfoFolioData = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.GETFILE_BY_FOLIO_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.GETFILE_BY_FOLIO_SUCCESS:
            return { loading: false, items: action.fileFolioData.Body, error: undefined }

        case fileConstants.GETFILE_BY_FOLIO_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const FolioExterno = (state = {}, action) => {
    switch (action.type) {
        case fileConstants.GENERATE_FOLIO_EXTERNO_REQUEST:
            return { loading: true, items: undefined, error: undefined }

        case fileConstants.GENERATE_FOLIO_EXTERNO_SUCCESS:
            return { loading: false, items: action.folioExtData.Body, error: undefined }

        case fileConstants.GENERATE_FOLIO_EXTERNO_FAILURE:
            return { loading: false, items: undefined, error: action.error }

        default:
            return state
    }
}

export const RegisterSurveyAnswers = (state = {}, action) => {
  switch (action.type) {
    case fileConstants.SURVEY_SEND_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case fileConstants.SURVEY_SEND_SUCCESS:
      return { loading: false, items: action.Body, error: undefined };

    case fileConstants.SURVEY_SEND_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};

export const GetSurveyQuestions = (state = {}, action) => {
  switch (action.type) {
    case fileConstants.GET_SURVEY_REQUEST:
      return { loading: true, items: undefined, error: undefined };

    case fileConstants.GET_SURVEY_SUCCESS:
      return { loading: false, items: action?.surveyInfo?.Body, error: undefined };

    case fileConstants.GET_SURVEY_FAILURE:
      return { loading: false, items: undefined, error: action.error };

    default:
      return state;
  }
};